export {
  AcquisitionPopupContainer,
  type Props as AcquisitionPopupContainerProps,
} from "./component";

export { getLoginDialogTitleAndDescription } from "./display/helpers";
